import React from 'react';
import axios from 'axios';
import { showToast, ToastMessage } from '../../Shared/ToastMessage';
import { baseUrl } from '../../../api/common';

const AdminUserRoleDelete = ({ fetchRoleTypeData,deletePopupStatus, handleCloseDelete, deleteId }) => {
  const deleteAdminUserRole = async () => {
    try {
      console.log(deleteId, 'deleteId');
      const response = await axios.post(
        `${baseUrl}/api/delete_role`,
        { id: deleteId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem('access_token'),
          },
        }
      );

      if (response.data.status) {
        showToast(response.data.message, "success");
        fetchRoleTypeData();
        handleCloseDelete();
      } else {
        showToast(response.data.message, "error");
      }
    } catch (error) {
      console.error("Error during submission:", error);
      showToast("Submission failed. Please try again.", "error");
    }
  };

  return (
    <>
      <ToastMessage />
      {deletePopupStatus && (
        <div className="modal fade d-block show">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Deletion</h5>
                <button
                  type="button"
                  className="close"
                  onClick={handleCloseDelete}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this Admin User Role?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-round btn-default"
                  onClick={handleCloseDelete}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-round btn-danger"
                  onClick={deleteAdminUserRole}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminUserRoleDelete;
